import { ProxyProfile } from '../common/shared-dtos-proxy-profile-common';

// DB module format
export interface RelayModule {
  communication: RelayCommunicationSection;
  update: RelayUpdateSection;
}

export interface RelayCommunicationSection {
  automaticDiscovery: boolean;
  whitelistedDomains: WhitelistedDomainItem[];
  cloudServicesProxy: {
    profile: ProxyProfile;
  };
  applianceProxy: {
    profile: ProxyProfile;
  };
}

export interface RelayUpdateSection {
  updateInterval: {
    enable: boolean;
    hours: number;
  };
  downloadFolder: string;
  updateLocations: {
    enable: boolean;
    locations: RelayUpdateLocationItem[];
  };
}

export interface RelayUpdateLocationItem {
  server: string;
  useProxy: boolean;
}

export enum WhitelistedDomainsColumns {
  TARGET_NAME = 'name',
}

export interface WhitelistedDomainItem {
  [WhitelistedDomainsColumns.TARGET_NAME]: string;
}
